export default __webpack_public_path__ + "static/N0122-3e966bd008bb8fb06adc93089dc68e7f.png";